<template>
    <Modal :modal-title="title"
           :dialog="holidayFormVisibility"
           max-width="600px"
           :persistent="true"
           :closeIcon="false"
           dense
           data-test="modal"
           @keydown.enter="showConfirmation"
           @keydown.esc="closeWithConfirmation"
           @close="close"
           @visibility="visibility($event)">
        <template slot="content">
            <ManageHolidayForm ref="form"></ManageHolidayForm>
            <ConfirmationDialog :dialog="showConfirmationDialog"
                                data-test="ConfirmationDialog"
                                @confirm="handleConfirmation($event)"
                                :text="$t('messages.save_changes')"
                                :action-button-title="$t('buttons.save')"></ConfirmationDialog>
            <ValidationError v-if="showError"></ValidationError>
        </template>
        <template slot="actions">
            <v-layout align-center
                      justify-end
                      class="mt-3">
                <v-btn color="secondary"
                       outlined
                       class="mr-3"
                       data-test="closeBtn"
                       @click="close">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn color="secondary"
                       data-test="saveBtn"
                       :loading="loader"
                       :disabled="loader"
                       @click="save">{{ $t('buttons.save') }}</v-btn>
            </v-layout>
        </template>
    </Modal>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '@/components/templates/Modal';
import ConfirmationDialog from '@/components/widgets/dialogs/ConfirmationDialog';
import ValidationError from '@/components/widgets/ValidationError';
import ManageHolidayForm from '@/components/holidaysCalendar/manageHoliday/ManageHolidayForm';

export default {
    name: 'ManageHoliday',
    components: { Modal, ConfirmationDialog, ValidationError, ManageHolidayForm },
    data: () => ({
        showConfirmationDialog: false,
        loader: false,
        showError: false
    }),
    computed: {
        ...mapState('holidaysCalendar', [
            'holidayFormVisibility',
            'editedHolidayId'
        ]),
        isFieldsDirty () {
            return this.$refs.form.isFormDirty;
        },
        isEditable () {
            return this.editedHolidayId !== null;
        },
        title () {
            return this.isEditable
                ? this.$t('settings.holidays_calendar.edit_title')
                : this.$t('settings.holidays_calendar.add_title');
        }
    },
    methods: {
        close () {
            this.$store.commit('holidaysCalendar/SET_HOLIDAY_FORM_VISIBILITY', false);
            this.$store.commit('holidaysCalendar/RESET_HOLIDAY_DATA');
            if (this.isEditable) {
                this.$store.commit('holidaysCalendar/SET_EDITED_HOLIDAY_ID', null);
            }
            this.showError = false;
            this.$refs.form.resetValidation();
        },
        visibility (event) {
            this.$store.commit('holidaysCalendar/SET_HOLIDAY_FORM_VISIBILITY', event);
        },
        closeWithConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            } else {
                this.close();
            }
        },
        showConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            }
        },
        updateHoliday () {
            this.loader = true;

            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        return this.$store.dispatch('holidaysCalendar/updateHoliday')
                            .then(() => {
                                this.$emit('fetch');
                                this.close();
                            })
                            .finally(() => {
                                this.loader = false;
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        createHoliday () {
            this.loader = true;

            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        return this.$store.dispatch('holidaysCalendar/createHoliday')
                            .then(() => {
                                this.$emit('fetch');
                                this.close();
                            })
                            .finally(() => {
                                this.loader = false;
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        save () {
            if (this.isEditable) {
                this.updateHoliday();
            } else {
                this.createHoliday();
            }
        },
        handleConfirmation (event) {
            if (event) {
                this.save();
                this.showConfirmationDialog = false;
            } else {
                this.showConfirmationDialog = false;
            }
        }
    }
};
</script>

<style scoped>

</style>
